/** Poll at least this far apart, whatever the server asks for. */
export const MIN_POLL_MS = 5000;
export const DEFAULT_POLL_SECONDS = 60;

/** Whether the app should be replaced by the maintenance screen. */
export const shouldShowGate = (maintenance) =>
  Boolean(maintenance && maintenance.active && !maintenance.bypass);

/** Whether an axios error is the maintenance gate refusing the call. */
export const isMaintenanceResponse = (error) =>
  error?.response?.status === 503 && error.response.data?.maintenance === true;

/**
 * How long to wait before the next status check, or null to stop while the
 * tab is hidden. Jitter only ever shortens the wait, so a window that the
 * server says starts in N seconds is never noticed late.
 */
export function nextPollDelay(maintenance, { hidden = false, random = Math.random } = {}) {
  if (hidden) return null;
  const seconds = maintenance?.pollSeconds > 0 ? maintenance.pollSeconds : DEFAULT_POLL_SECONDS;
  const jitter = 0.8 + random() * 0.2;
  return Math.max(MIN_POLL_MS, Math.round(seconds * 1000 * jitter));
}

export function toPlainText(html) {
  if (!html) return "";
  const text =
    typeof DOMParser !== "undefined"
      ? new DOMParser().parseFromString(String(html), "text/html").body.textContent
      : String(html).replace(/<[^>]*>/g, " ");
  return (text || "").replace(/\s+/g, " ").trim();
}

/** "2 h 5 min", "12 min", "less than a minute". */
export function formatRemaining(ms) {
  const totalMinutes = Math.floor(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours) return minutes ? `${hours} h ${minutes} min` : `${hours} h`;
  if (minutes) return `${minutes} min`;
  return "less than a minute";
}
